import React from 'react';
import classNames from 'classnames';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@pwc/pwc-deals-ui';
import resetAllToggles from '../../../../common/engine/actions/resetAllToggles';
import { getAreAdjustmentsToggledFromDefault } from '../../../../common/engine/selectors/adjustmentTogglesSelectors';
import viewingToggledUpdated from '../../../../common/engine/actions/viewingToggledUpdated';
import { getIsViewingToggled } from '../../../../common/engine/reducers/calcEngine';
import './ClientManipulationBar.scss';

const ClientManipulationBar = () => {
  const dispatch = useDispatch();
  const shouldShow = useSelector(getAreAdjustmentsToggledFromDefault);
  const defaultTooltip = `Switch to the default
  figures proposed by PwC`;
  const yourTooltip = `Switch to your
  modifications`;

  const isViewingToggled = useSelector(getIsViewingToggled);

  return shouldShow ? (
    <div
      className="client-manipulation-bar"
      data-testid="client-manipulation-bar"
    >
      <Helmet>
        <body data-appbanner={isViewingToggled ? 'open' : 'closed'} />
      </Helmet>
      <div className="toggles">
        <Tooltip
          direction="top"
          tip={yourTooltip}
          dataTestId="your-view-tooltip"
        >
          <button
            className={classNames(isViewingToggled ? 'active your-view' : null)}
            type="button"
            data-testid="your-view-toggle"
            onClick={() => dispatch(viewingToggledUpdated(true))}
          >
            Your View
          </button>
        </Tooltip>
        <Tooltip
          direction="top"
          tip={defaultTooltip}
          dataTestId="view-default-tooltip"
        >
          <button
            type="button"
            className={classNames(
              !isViewingToggled ? 'active pwc-default' : null
            )}
            data-testid="view-default-toggle"
            onClick={() => dispatch(viewingToggledUpdated(false))}
          >
            PwC Default
          </button>
        </Tooltip>
      </div>
      <button
        className="reset-all"
        type="button"
        data-testid="toggle-reset-all"
        onClick={() => dispatch(resetAllToggles())}
      >
        Reset All
      </button>
    </div>
  ) : null;
};

export default ClientManipulationBar;
